import { render, staticRenderFns } from "./NewMessageTemplatePreview.vue?vue&type=template&id=2b84de56&scoped=true"
import script from "./NewMessageTemplatePreview.vue?vue&type=script&lang=js"
export * from "./NewMessageTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./NewMessageTemplatePreview.vue?vue&type=style&index=0&id=2b84de56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84de56",
  null
  
)

export default component.exports